import { render } from "./HeroiconsOutlineTrendingDown.vue?vue&type=template&id=5630f885"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTrendingDown.vue"]])

export default __exports__